import { CountrySelector } from "../Country/CountrySelector";
import { EditClinic} from "../Clinic/EditClinic";
import { FormItemList } from "../FormHelper/FormItemList";
import { ClinicManager} from "../Clinic/ClinicManager";
import { SHCustomize } from "../SpecialtyHospital/SHCustomize";
import { PrivacyAgreement } from "../PrivacyAgreement/PrivacyAgreement";
import { LionList } from '../LionManager/LionList';
import { ShareCase} from '../Worklist/ShareCase';

export class VetologyClassLoader
{
	constructor()
	{
		const _self = this;
		_self.classInstances = [];
		_self.classMap = {
		    CountrySelector,
			ClinicManager,
			EditClinic,
			SHCustomize,
			PrivacyAgreement,
            LionList,
            ShareCase,
			FormItemList
		};
	}


	init()
	{
		const _self = this;
		_self.classInstances = [];

		_self.initEventHandlers();
	}

	initEventHandlers()
	{
		const _self = this;

		_self.onLoadPage = _self.onLoadPage.bind(_self);
		document.addEventListener('vetology-load-page-event', (event) => { _self.onLoadPage(event); });
		_self.onUnloadPage = _self.onUnloadPage.bind(_self);
		document.addEventListener('vetology-unload-page-event', (event) => { _self.onUnloadPage(event); });
	}

	onLoadPage(event)
	{
		const _self = this;
		const className = event.detail.className;
        if (!_self.classMap.hasOwnProperty(className)) {
            return;
        }
		try {
			const cls = new _self.classMap[className]();
			cls.init();
			_self.classInstances.push(cls);
		} catch (error) {
			console.log(error);
		}
	}




	onUnloadPage(event)
	{
		const _self = this;
		_self.classInstances.forEach(cls => {
			console.log(cls);
			console.log(typeof cls);
			if (typeof cls.removeEventHandlers === "function") {
				cls.removeEventHandlers();
			}
		});
		_self.classInstances = [];
	}
}

// one and only instance
const classLoader = new VetologyClassLoader();
classLoader.init();